module.exports = __webpack_public_path__ + "static/media/checkAccordion.55d3a86d.svg";